import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sqit_access_token";
const REFRESH_KEY = "sqit_refresh_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_KEY),
  set: (a, r) => {
    if (a) localStorage.setItem(TOKEN_KEY, a);
    if (r) localStorage.setItem(REFRESH_KEY, r);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const status = err.response?.status;
    if (status === 401 && !orig._retry && tokenStore.getRefresh()) {
      orig._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${API_BASE}/auth/refresh`, { refresh_token: tokenStore.getRefresh() });
        const { data } = await refreshing;
        refreshing = null;
        tokenStore.set(data.access_token, data.refresh_token);
        orig.headers.Authorization = `Bearer ${data.access_token}`;
        return api(orig);
      } catch (_) {
        refreshing = null;
        tokenStore.clear();
      }
    }
    return Promise.reject(err);
  }
);
